<template>
    <g>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M21 7H14C12.3431 7 11 8.34315 11 10V22C11 23.6569 12.3431 25 14 25H21V23H14C13.4477 23 13 22.5523 13 22V10C13 9.44772 13.4477 9 14 9H21V7Z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M24 15H16.5V17H24V15Z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19 11.5858L15.2929 15.2929C14.9024 15.6834 14.9024 16.3166 15.2929 16.7071L19 20.4142L20.4142 19L17.4142 16L20.4142 13L19 11.5858Z"/>
    </g>
</template>
